import React, { useEffect, useState } from 'react';
import { Building2, Loader2 } from 'lucide-react';
import { customersAPI } from '../../services/api';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { toast } from 'sonner';

export const AssignInquiryCustomerDialog = ({ open, onOpenChange, currentCustomerId, onAssign, saving }) => {
  const [customers, setCustomers] = useState([]);
  const [customerId, setCustomerId] = useState(currentCustomerId || '');

  useEffect(() => {
    if (!open) return;
    customersAPI.list({ is_active: true }).then((response) => setCustomers(response.data?.items || response.data || []))
      .catch(() => toast.error('Failed to load customers'));
  }, [open]);

  return <Dialog open={open} onOpenChange={onOpenChange}><DialogContent data-testid="assign-inquiry-customer-dialog">
    <DialogHeader><DialogTitle>Assign customer</DialogTitle><DialogDescription>Link this inquiry to Customer Master before generating a quotation.</DialogDescription></DialogHeader>
    <Select value={customerId} onValueChange={setCustomerId}><SelectTrigger data-testid="assign-inquiry-customer-select"><SelectValue placeholder="Select customer" /></SelectTrigger>
      <SelectContent>{customers.map((customer) => <SelectItem key={customer.id} value={customer.id}>{customer.name}</SelectItem>)}</SelectContent></Select>
    <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)} data-testid="assign-inquiry-customer-cancel-button">Cancel</Button>
      <Button onClick={() => onAssign(customerId)} disabled={!customerId || saving} data-testid="assign-inquiry-customer-confirm-button">
        {saving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Building2 className="mr-2 h-4 w-4" />} Assign customer
      </Button></DialogFooter>
  </DialogContent></Dialog>;
};